export const parseContentDispositionFileName = (contentDisposition) => {
    if (!contentDisposition)
        return null

    const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition)
    if (utf8Match) {
        try {
            return decodeURIComponent(utf8Match[1])
        } catch (error) {
            return utf8Match[1]
        }
    }

    const match = /filename="?([^";]+)"?/i.exec(contentDisposition)
    return match ? match[1] : null
}

export const resolveMediaFileName = async (url) => {
    if (!url)
        return null

    try {
        const response = await fetch(url, { method: 'HEAD' })
        return parseContentDispositionFileName(response.headers.get('Content-Disposition'))
    } catch (error) {
        return null
    }
}

export const stripHashSuffix = (fileName) => {
    if (!fileName)
        return fileName

    const match = /^(.*)-[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\.[^./]*)?$/.exec(fileName)

    return match ? `${match[1]}${match[2] || ''}` : fileName
}
